import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPatchSegmentDeclaration, TSegmentDeclaration } from '../types';

type TPatchSegmentDeclarationBody = {
  id: string;
  body: TPatchSegmentDeclaration;
};
export async function patchSegmentDeclaration({
  id,
  body,
}: TPatchSegmentDeclarationBody): Promise<TSegmentDeclaration> {
  return mediaManagerClient
    .patch(`/api/v1/segment_declarations/${id}`, emptyStringValues(body))
    .then(response => response as unknown as TSegmentDeclaration);
}

type MutationFn = typeof patchSegmentDeclaration;

type TUsePatchSegmentDeclarationParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchSegmentDeclaration({ config }: TUsePatchSegmentDeclarationParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchSegmentDeclaration,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la declaración del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La declaración del segmento se ha actualizado correctamente'));
    },
  });
}
